module.exports = __webpack_public_path__ + "static/media/rams-pennant.08e8e2bd.png";